import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Styles: the design system (src/ds) is the only stylesheet source, plus the element base
// and the sanctioned Auth one-off (D-36). Screens never import CSS (MAR-372).
import './index.css'
import './styles/marva-auth.css'
import './ds/tokens.css'
import './ds/base.css'
import './ds/components.css'
import './ds/shell.css'
import './ds/collections.css'
import './ds/settings.css'
import './ds/flow.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)